import React from 'react';
import Footer from './Footer';
import weddingPointsOfInterest from './weddingLocations';
import './EventSchedule.css';

const locationLinks = weddingPointsOfInterest.reduce((links, location) => {
    links[location.name] = location.link;
    return links;
}, {});

const scheduleDays = [
    {
        date: 'Friday, September 11th',
        subtitle: 'Welcome Events',
        secondary: true,
        events: [
            {
                time: '11:00 AM',
                title: 'Mid Morning Hike',
                location: 'Monument Mountain Trailhead',
                locationLink: locationLinks['Monument Mountain Trailhead'],
                description: 'If you arrive to the area early, please join us Friday morning for a scenic ~3 mile hike. Bring water, and snacks if desired. The wedding party will depart from the Old Inn on The Green at 10:30am. Meet at the Old Inn if convenient, or at the trailhead at 11am.'
            }
        ]
    },
    {
        date: 'Saturday, September 12th',
        subtitle: 'Wedding Day',
        events: [
            {
                time: '4:00 PM',
                title: 'Ceremony',
                location: 'New Marlborough Meeting House',
                locationLink: locationLinks['New Marlborough Meeting House'],
                description: 'Wedding ceremony and vows'
            },
            {
                time: '4:30 PM',
                title: 'Lawn Games',
                location: 'Lawn outside the Meeting House',
                description: 'Weather permitting, gather on the lawn for games and chatting before the reception'
            },
            {
                time: '5:30 PM',
                title: "Hors D'oeuvres",
                location: 'Old Inn on the Green',
                locationLink: locationLinks['Old Inn on the Green'],
                description: 'Light refreshments to kick off the celebration'
            },
            {
                time: '6:00 PM',
                title: 'Dinner',
                location: 'Old Inn on the Green',
                locationLink: locationLinks['Old Inn on the Green'],
                description: 'Farm-to-table dinner under the tent on the grounds of the Old Inn'
            },
            {
                time: (
                    <>
                        9:00 PM<br />- 11:00 PM
                    </>
                ),
                title: 'Dancing',
                location: 'Old Inn on the Green',
                locationLink: locationLinks['Old Inn on the Green'],
                description: 'Live music and dancing! '
            }
        ]
    },
    {
        date: 'Sunday, September 13th',
        subtitle: 'Morning After',
        secondary: true,
        events: [
            {
                time: (
                    <>
                        Starting at<br />10:00 AM
                    </>
                ),
                title: 'Farewell Brunch',
                location: 'Mill River House',
                locationLink: locationLinks['Mill River House'],
                description: 'Join us for a casual brunch and coffee at the groom\'s grandparent\'s home in Mill River before saying goodbye'
            }
        ]
    }
];

function ScheduleEvent({ event }) {
    return (
        <div className="event-card">
            <div className="event-time">{event.time}</div>
            <div className="event-details">
                <div className="event-title-row">
                    <h3>{event.title}</h3>
                    {event.badge && <span className="event-badge">{event.badge}</span>}
                </div>
                <p className="event-location">
                    {event.locationLink ? (
                        <a href={event.locationLink} target="_blank" rel="noopener noreferrer">
                            {event.location}
                        </a>
                    ) : (
                        event.location
                    )}
                </p>
                <p className="event-description">{event.description}</p>
            </div>
        </div>
    );
}

function ScheduleDay({ day }) {
    return (
        <section className={`schedule-day${day.secondary ? ' day-secondary' : ''}`}>
            <div className="day-header">
                <h2 className="section-title">{day.date}</h2>
                <span className="section-subtitle">{day.subtitle}</span>
            </div>

            <div className="events-timeline">
                {day.events.map((event) => (
                    <ScheduleEvent event={event} key={`${day.date}-${event.title}`} />
                ))}
            </div>
        </section>
    );
}

function EventSchedule() {
    return (
        <div className="schedule">
            <header className="page-header">
                <br /><br />
                <div className="page-header-image-layer" aria-hidden="true"></div>
                <h1>Event Schedule</h1>
                <p></p>
                <br />
            </header>

            <div className="botanical-wrapper">
                <div className="botanical-left"></div>
                <div className="botanical-right"></div>

                {scheduleDays.map((day) => (
                    <ScheduleDay day={day} key={day.date} />
                ))}
            </div>

            <Footer />
        </div>
    );
}

export default EventSchedule;
